import { Field, RawJsonField } from "sparkson";

export class Animation {
  constructor(
    @Field("s") public src: string,
    @Field("st", true) public startTimeMillis: number = 0,
    @Field("et", true) public endTimeMillis?: number,
    @Field("t", true) public type: "L" = "L",
    @Field("da", true) public displayAbovePoster: boolean = true,
    @Field("blr", true) public animationBlur: string = "0.4px",
    @RawJsonField("c", true) public customAttributes?: any,
  ) {}
}
